/** @format */
/** @format */

import React, { useState } from "react";
import Dropzone from "react-dropzone";

export const DROPZONE_MAX_FILE_SIZE_MB = 5;

const ACCEPTABLE_FILE_TYPES = { "image/png": [".png"] };

const ACCEPTABLE_PROCESSED_FILE_TYPES_READABLE = "PNG";

const ErrorText = ({ children }) => (
  <div
    className="input-feedback"
    style={{
      color: "#dd2b0e",
      fontSize: "13px",
      paddingTop: "4px",
      fontWeight: "500",
    }}
  >
    {children}
  </div>
);

const FileUploadButton = ({ id, ...props }) => {
  let [logoError, setLogoError] = useState();

  const onDrop = async (acceptedFiles, fileRejections) => {
    if (fileRejections && fileRejections.length > 0) {
      const errorText = fileRejections
        .map((fr) =>
          fr.errors
            .map((e) => {
              switch (e.code) {
                case "file-invalid-type":
                  return `Unexpected file type. Please upload a ${ACCEPTABLE_PROCESSED_FILE_TYPES_READABLE}.`;
                case "file-too-large":
                  return `File too large. Maximum allowed size is ${DROPZONE_MAX_FILE_SIZE_MB} MB.`;
                default:
                  return e.message;
              }
            })
            .join(", ")
        )
        .join(", ");
      setLogoError(errorText);
    } else {
      setLogoError(undefined);
      props.setFieldValue(id, acceptedFiles);
    }
  };

  const files = props.values[id];
  return (
    <Dropzone
      accept={ACCEPTABLE_FILE_TYPES}
      maxSize={DROPZONE_MAX_FILE_SIZE_MB * 1024 * 1024}
      onDrop={onDrop}
      noClick={true}
      noKeyboard={true}
      multiple={false}
    >
      {({ getRootProps, getInputProps, isDragActive, open }) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />

          {files && files.length > 0 && (
            <div className={"d-flex"}>
              <p>{files[0].name}</p>{" "}
              <small>
                <button
                  className={"resetButton bk-button"}
                  onClick={() => props.setFieldValue(id, [])}
                >
                  remove
                </button>
              </small>
            </div>
          )}
          {!(files && files.length > 0) && (
            <button
              className={
                "contactButton bk-button" + (isDragActive ? " active" : "")
              }
              type={
                "button" /* seem to need this to avoid somebody trying to be smart and treating this click like a submit?*/
              }
              onClick={open}
              disabled={false /* TODO isSubmitting */}
            >
              {props.btnLabel}
            </button>
          )}
          {logoError && <ErrorText>{logoError}</ErrorText>}
        </div>
      )}
    </Dropzone>
  );
};

export default FileUploadButton;
